import './contact-qualification.component.ajscss';

import { AppointmentQualificationStatus, IAppointmentDeprecatedService } from '@agent/core/contact/appointment-deprecated.service';
import { SessionDeprecatedService } from '@commons/core/auth/session-deprecated.service';
import { ToastDeprecatedService } from '@commons/core/notification/toast-deprecated.service';
import { HttpDeprecatedService } from '@commons/core/transport/http-deprecated.service';
import { IAppointment } from '@commons/models/appointment';
import { AppointmentQualificationDto } from '@commons/models/appointment-qualification';
import { PostContactReportDto } from '@commons/models/post-contact-report';
import { IChangesObject, IComponentController, IComponentOptions, ILogService } from 'angular';
import { i18n } from 'i18next';

import { CSR_FACADE_PREFIX, QualifField, QualificationService, ToastClass, ToastType } from '@contact/upgrade';

import templateUrl from './contact-qualification.component.ajs.html';

class ContactQualificationCtrl implements IComponentController {
  // params
  currentAppointment: IAppointment;

  // the object displayed in the html
  availableQualificationStatus: AppointmentQualificationStatus[] = [
    AppointmentQualificationStatus.SUCCESS,
    AppointmentQualificationStatus.CANCELED,
  ];
  fields: QualifField[];

  selectedStatus: AppointmentQualificationStatus = AppointmentQualificationStatus.SUCCESS;

  constructor(
    private readonly $log: ILogService,
    protected readonly $i18next: i18n,
    private readonly httpDeprecated: HttpDeprecatedService,
    private readonly appointmentDeprecatedService: IAppointmentDeprecatedService,
    private readonly sessionDeprecatedService: SessionDeprecatedService,
    private readonly toastDeprecatedService: ToastDeprecatedService,
    private readonly qualificationService: QualificationService
  ) {}

  get isFormValid(): boolean {
    // if already closed
    if (this.currentAppointment.closed) {
      return false;
    }

    // there is no fields
    if (this.fields.length === 0) {
      return true;
    }

    // are all mandatory fields valued ?
    return this.fields.every(f => !f.required || f.value !== '');
  }

  $onInit(): void {
    this.refreshContents();
  }

  $onChanges(onChangesObj: { [property: string]: IChangesObject }): void {
    this.currentAppointment = onChangesObj['currentAppointment'].currentValue;
    this.$log.debug('[contactQualificationView] current postQualif [' + JSON.stringify(this.currentAppointment) + ']');
    this.refreshContents();
  }

  refreshContents(): void {
    this.fields = [];

    let streamUuid: string = (this.currentAppointment.campaign.stream && this.currentAppointment.campaign.stream.uuid) || '';
    let campaignId: string = this.currentAppointment.campaign.id;
    let skillList: string[] = this.currentAppointment.skillList.map(s => s.id);

    this.httpDeprecated
      .asPromise()
      .withData(skillList)
      .withConfig({
        headers: {
          'Content-Type': 'text/plain; charset=UTF-8',
          Accept: 'application/json',
        },
      })
      .post(CSR_FACADE_PREFIX + '/getPostTreatmentForAppointmentQualification', [streamUuid, campaignId])
      .then(
        success => {
          this.fields = success.data.map((field, i) => this.qualificationService['dtoToQualifRootField'](field, i));
        },
        error => {
          this.toastDeprecatedService.alert(this.$i18next.t('agent:toast.appointment_qualification_fields_error'));
          this.$log.error(error);
        }
      );
  }

  getStatusLabel(status: AppointmentQualificationStatus): string {
    const statusKey = AppointmentQualificationStatus[status].toLowerCase();
    return this.$i18next.t('agent:contact.appointment.qualification.status.' + statusKey);
  }

  qualifyAndClose(): void {
    this.appointmentDeprecatedService
      .closeAppointment(
        PostContactReportDto.toDto(
          this.selectedStatus,
          this.currentAppointment,
          this.fields,
          this.sessionDeprecatedService.getProfile().id,
          this.sessionDeprecatedService.getProfile().login,
          [],
          'CANCELED_FROM_HISTORY',
          'CLOSE'
        )
      )
      .then(
        () => {
          let dataToSend: AppointmentQualificationDto = AppointmentQualificationDto.fromData(
            this.currentAppointment,
            this.fields,
            this.selectedStatus
          );

          // this request is used for csr tracking action and is not critical
          this.httpDeprecated
            .asPromise()
            .withData(dataToSend)
            .withConfig({
              headers: {
                'Content-Type': 'text/plain; charset=UTF-8',
                Accept: 'application/json',
              },
            })
            .post(CSR_FACADE_PREFIX + '/qualifyAppointment')
            .finally(() => {
              // even if this request failed the appointment has been closed
              // so update object
              this.currentAppointment.closed = true;
              this.toastDeprecatedService.add(
                ToastType.NOTIFICATION,
                this.$i18next.t('agent:toast.appointment_closing_success'),
                ToastClass.CONTACT,
                5 * 1000
              );
            });
        },
        error => {
          this.toastDeprecatedService.alert(this.$i18next.t('agent:toast.appointment_closing_error'));
          this.$log.error(error);
        }
      );
  }
}

export class ContactQualification implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    currentAppointment: '<',
  } as { [binding: string]: string };
  controller = [
    '$log',
    '$i18next',
    'httpDeprecated',
    'appointmentDeprecatedService',
    'sessionDeprecatedService',
    'toastDeprecatedService',
    'qualificationService',
    ContactQualificationCtrl,
  ];
}

export default 'contactQualificationView';
